import React, { useEffect, useMemo, useContext } from 'react';
import { connect } from 'react-redux';
import { Box, Card, Image, Heading, Menu, Header, Text } from 'grommet';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import * as SidebarDucks from 'granite-admin/accounts/ducks/sidebar';
import * as UserDucks from 'granite-admin/accounts/ducks/user';
import * as OrganisationDucks from 'granite-admin/organisations/ducks/organisations';
import * as ThemeConfigsDucks from 'granite-admin/common/ducks/themeConfigs';
import Loader from 'granite-admin/core/components/Loader';
import { loadMenuItemsAndPermissions } from 'granite-admin/accounts/controllers/sidebar';
import useWindowDimensions from 'granite-admin/utils/useWindowDimensions';
import useUtility from 'granite-admin/utils/useUtility';
import { ConfigContext } from 'granite-admin/core/components/ConfigProvider';
import logo from 'assets/logo.png';
import UserDropMenu from './components/UserDropMenu';
import Notification from './components/Notification';
import { getOrganisationAvatar } from './components/UserDropMenu';
import MoreLeftItems from './components/MoreLeftItems';
import { parseTopMenuItems } from './utils';
import TopNavbarSkeletonLoader from './components/TopNavbarSkeletonLoader';
const HeaderBox = styled(Header)`
  top: 0;
  left: 0;
  z-index: 1;
  padding: 5px 10px;
  height: 54px;
  align-items: center;
`;
function fetchSidemenuItems(dispatch) {
  loadMenuItemsAndPermissions().then(response => {
    dispatch({
      type: 'accounts/sidebar/UPDATE_SIDEBAR',
      data: response
    });
  }).catch(error => console.log('page error', error));
}
const getItemCount = dimension => {
  if (dimension.width < 1000) return 4;else if (dimension.width < 1200) return 5;else if (dimension.width < 1400) return 6;else if (dimension.width < 1600) return 7;else return 8;
};
const TopNavbar = ({
  sidebarItems,
  history,
  title,
  userProfile,
  dispatch,
  theme,
  showUserDropMenu,
  selectedOrganisation,
  getItemCount,
  themeConfigs
}) => {
  const config = useContext(ConfigContext);
  const {
    TopNavCustomLeftComp,
    TopNavCustomRightComp
  } = config?.sidebarSettings;
  const projectName = process.env.REACT_APP_PROJECT_NAME || 'Granite';
  const windowDimensions = useWindowDimensions();
  const grandListner = React.useCallback(event => {
    switch (event.type) {
      case 'UPDATE_SIDEBAR':
        fetchSidemenuItems(dispatch);
        break;
      default:
        break;
    }
  }, [dispatch]);
  useUtility({
    grandListner
  });
  useEffect(() => {
    if (sidebarItems.length === 0) fetchSidemenuItems(dispatch);
  }, [dispatch, sidebarItems]);
  const signOut = async () => {
    document.title = `${projectName}`;
    history.push('/logout');
  };
  const navItems = useMemo(() => parseTopMenuItems(sidebarItems), [sidebarItems]);
  const menuItems = useMemo(() => {
    return {
      visibleItems: [...navItems].splice(0, getItemCount(windowDimensions)),
      moreItems: [...navItems].splice(getItemCount(windowDimensions))
    };
  }, [navItems, getItemCount, windowDimensions]);
  return /*#__PURE__*/React.createElement(HeaderBox, {
    background: theme.global.colors['sidebar-background'],
    fill: "horizontal",
    direction: "row",
    gap: "small",
    border: {
      side: 'bottom',
      color: 'brand',
      size: '1px'
    },
    wrap: true
  }, sidebarItems.length === 0 && config?.showSkeletonLoader ? /*#__PURE__*/React.createElement(TopNavbarSkeletonLoader, null) : sidebarItems.length === 0 ? /*#__PURE__*/React.createElement(Box, {
    align: "center",
    justify: "center",
    fill: true
  }, /*#__PURE__*/React.createElement(Loader, {
    size: "30px"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    flex: {
      shrink: 0
    },
    margin: {
      right: 'auto'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    gap: "small",
    align: "center",
    flex: {
      shrink: 0
    },
    height: "42px"
  }, themeConfigs?.logo || selectedOrganisation?.logo?.thumbnails ? /*#__PURE__*/React.createElement(Image, {
    src: themeConfigs?.logo || selectedOrganisation?.logo?.thumbnails,
    alt: "Company Logo",
    height: "42px"
  }) : typeof title === 'string' ? /*#__PURE__*/React.createElement(Heading, {
    margin: "none",
    level: 3
  }, title) : title, config?.showProductConsole && !selectedOrganisation?.pk ? /*#__PURE__*/React.createElement(Card, {
    pad: "xsmall"
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold",
    size: "small",
    margin: {
      bottom: '0px'
    }
  }, "Product Console")) : null), /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    alignSelf: "center",
    gap: "xsmall",
    align: "center",
    margin: {
      horizontal: 'small'
    }
  }, menuItems.visibleItems.map(child => /*#__PURE__*/React.createElement(MoreLeftItems, {
    key: child.group,
    subItems: child.children,
    label: child.label,
    theme: theme
  })), menuItems.moreItems.length > 0 && /*#__PURE__*/React.createElement(MoreLeftItems, {
    label: "More",
    subItems: menuItems.moreItems,
    theme: theme
  }), TopNavCustomLeftComp && /*#__PURE__*/React.createElement(TopNavCustomLeftComp, null))), /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    flex: {
      shrink: 0
    },
    margin: {
      left: 'auto'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    alignSelf: "center",
    gap: "xsmall"
  }, TopNavCustomRightComp && /*#__PURE__*/React.createElement(TopNavCustomRightComp, null)), /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    flex: {
      shrink: 0
    },
    justify: "center",
    align: "center",
    gap: "small"
  }, /*#__PURE__*/React.createElement(Notification, {
    history: history
  }), showUserDropMenu ? /*#__PURE__*/React.createElement(UserDropMenu, {
    userProfile: userProfile,
    selectedOrganisation: selectedOrganisation,
    history: history,
    signOut: signOut,
    dispatch: dispatch
  }) : /*#__PURE__*/React.createElement(Menu, {
    plain: true,
    items: [{
      label: 'Profile',
      onClick: () => history.push('/profile')
    }, {
      label: 'Logout',
      onClick: () => history.push('/logout')
    }]
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    align: "center",
    gap: "small",
    pad: {
      horizontal: 'small'
    }
  }, /*#__PURE__*/React.createElement(Text, null, userProfile.firstName), getOrganisationAvatar(userProfile)))))));
};
TopNavbar.propTypes = {
  history: PropTypes.object,
  title: PropTypes.any,
  userProfile: PropTypes.object,
  sidebarItems: PropTypes.array,
  dispatch: PropTypes.func,
  theme: PropTypes.object,
  showUserDropMenu: PropTypes.bool,
  selectedOrganisation: PropTypes.object,
  getItemCount: PropTypes.func,
  themeConfigs: PropTypes.object
};
TopNavbar.defaultProps = {
  title: /*#__PURE__*/React.createElement(Image, {
    src: logo,
    alt: "Logo",
    height: "40px"
  }),
  getItemCount: getItemCount
};
const mapStateToProps = state => ({
  sidebarItems: SidebarDucks.sidebarItems(state),
  userProfile: UserDucks.profile(state),
  // userPermissions: UserDucks.permissions(state),
  selectedOrganisation: OrganisationDucks.selectedOrganisation(state),
  themeConfigs: ThemeConfigsDucks.themeConfigs(state)
});
const mapDispatchToProps = dispatch => ({
  dispatch: dispatch
});
export default connect(mapStateToProps, mapDispatchToProps)(TopNavbar);